import { useState } from "react";

const formatDollars = (v) => (v === null || v === undefined ? "--" : `$${Math.round(v).toLocaleString()}`);
const formatPrice = (v) => (v === null || v === undefined ? "--" : `${Math.round(v * 100)}c`);

/** Informational only -- never labels either side "sharp money" and never claims a predicted
 * market direction. Purely: both YES and NO independently cleared the Big Money threshold on
 * the same market within the last 30 minutes. Same detection logic as before, just surfaced as
 * a row-level icon + hover/click tooltip instead of a top-of-page banner. */
export const TwoSidedWarningIcon = ({ warning }) => {
  const [open, setOpen] = useState(false);
  if (!warning) return null;

  return (
    <span
      className="relative inline-flex shrink-0"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      <button
        type="button"
        data-testid={`kalshi-two-sided-warning-icon-${warning.ticker}`}
        onClick={() => setOpen((o) => !o)}
        aria-label="Two-Sided Big Money warning"
        className="text-amber-400 transition-colors hover:text-amber-300"
      >
        &#9888;
      </button>
      {open && (
        <div
          data-testid={`kalshi-two-sided-warning-tooltip-${warning.ticker}`}
          className="absolute left-1/2 top-full z-20 mt-1.5 w-56 -translate-x-1/2 rounded-lg border border-amber-400/40 bg-eb-surface px-3 py-2 font-mono text-[11px] text-amber-300 shadow-xl"
        >
          <p className="font-semibold uppercase tracking-wide">Two-Sided Big Money</p>
          <p className="mt-1 text-amber-200">YES: {formatDollars(warning.yes_dollars)} @ {formatPrice(warning.yes_price)}</p>
          <p className="text-amber-200">NO: {formatDollars(warning.no_dollars)} @ {formatPrice(warning.no_price)}</p>
          <p className="mt-1 text-amber-400/70">Last {warning.window_minutes} min</p>
        </div>
      )}
    </span>
  );
};
